import { track_ga } from '../firebase'

// 点击查看活动规则
export const trackClickRules = (pageName) => {
  track_ga('act_tip', { page: pageName })
}
// 去下单按钮曝光
export const trackShowGainShots = (pageName) => {
  track_ga('act_ticket_show', { page: pageName })
}
// 点击去下单
export const trackGainShots = (pageName) => {
  track_ga('act_ticket_click', { page: pageName })
}
// 点击抽奖
export const trackClickTryOne = (pageName) => {
  track_ga('act_pull', { page: pageName })
}

// 点击连续抽十次
export const trackClickTryTen = (pageName) => {
  track_ga('act_10pulls', { page: pageName })
}

// 十连抽按钮曝光
export const trackShowTry10 = (pageName, status) => {
  track_ga('act_10pulls_show', { page: pageName, status })
}

// 中奖弹窗曝光
export const trackShowPrizePopup = (pageName) => {
  track_ga('act_result_show', { page: pageName })
}

// 点击去查看奖品入口
export const trackViewPrize = (pageName) => {
  track_ga('act_view_prize', { page: pageName })
}

// 中奖弹窗内点击去查看奖品
export const trackClickCheckPrize = (pageName) => {
  track_ga('act_result_use', { page: pageName })
}

// 礼品券列表页，礼品卡曝光
export const trackShowCoupon = (params) => {
  track_ga('coupon_show', { ...params })
}

// 礼品券列表页，点击去使用礼品
export const trackClickUseCoupon = (params) => {
  track_ga('coupon_use', { ...params })
}

// 充值页，点击手机号输入框
export const trackInputTel = (pageName) => {
  track_ga('account_tel_input', { page: pageName })
}

// 充值页，点击提交确认
export const trackSubmitTel = (pageName, couponId, result) => {
  track_ga('account_submit', { page: pageName, coupon_id: couponId, result })
}

// 详情页,活动入口曝光
export const trackActivityEntryShow = (params) => {
  track_ga('page_act_show', { ...params })
}

// 详情页,活动入口点击
export const trackActivityEntryClick = (params) => {
  track_ga('page_act_click', { ...params })
}
